/* HotDawgs — Hearthside signature motion.
   Two scroll-tied effects, both expressed as CSS custom properties so
   the styling stays in CSS and this file stays small:

   1. --warmth on .hero (0 → 1): burns off the cold blue cast as the
      hero scrolls past and lets the ember glow take over.
   2. --reveal on .reveal-media (0% → 100%): wipes the "after" photo
      across the "before" photo through the reveal section.

   Both properties have sane static fallbacks set in CSS, so if GSAP
   fails to load (or reduced motion is on) the page still looks
   intentional — just still, rather than mid-scroll. */

document.addEventListener('DOMContentLoaded', () => {
  if (!window.gsap || !window.ScrollTrigger) return;
  gsap.registerPlugin(ScrollTrigger);

  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduced) return;

  const hero = document.querySelector('.hero');
  if (hero) {
    ScrollTrigger.create({
      trigger: hero,
      start: 'top top',
      end: 'bottom top',
      scrub: 0.4,
      onUpdate: (self) => {
        hero.style.setProperty('--warmth', self.progress.toFixed(3));
      },
    });
  }

  const revealMedia = document.querySelector('.reveal-media');
  if (revealMedia) {
    ScrollTrigger.create({
      trigger: '.reveal-stage',
      start: 'top 78%',
      end: 'bottom 38%',
      scrub: 0.4,
      onUpdate: (self) => {
        revealMedia.style.setProperty('--reveal', (self.progress * 100).toFixed(1) + '%');
      },
    });
  }
});
